import React, {Component} from 'react'
import {inject, observer} from 'mobx-react'
import { Modal, Table, Spin, Descriptions } from 'antd'
import {withTranslation} from 'react-i18next'

@inject('emailListStore')
@observer
class FormModal extends Component {
  state = {
  }
  componentDidMount() {
  }
  getRowClassName = (record, index) => {
    let className = ''
    className = index % 2 === 0 ? 'oddRow' : 'evenRow'
    return className
  }
  render() {
    const { emailListStore, addModalVisible, handleCancel } = this.props
    const { isFetchingEmailTotal, overviewResult } = emailListStore
    return (
      <>
        <Modal
          title='活跃邮箱统计'
          closable={true}
          visible={addModalVisible}
          onCancel={handleCancel}
          maskClosable={false}
          destroyOnClose={true}
          width={'60%'}
          centered
          footer={false}
        >
          <Spin spinning={isFetchingEmailTotal}>
            <Descriptions column={4}>
              <Descriptions.Item label="打开人数">{overviewResult?.openUnique}</Descriptions.Item>
              <Descriptions.Item label="打开次数">{overviewResult?.openTotal}</Descriptions.Item>
              <Descriptions.Item label="首次打开时间">{overviewResult?.openFirst==='0000-00-00 00:00:00' ? null : overviewResult?.openFirst}</Descriptions.Item>
              <Descriptions.Item label="最后打开时间">{overviewResult?.openLast==='0000-00-00 00:00:00' ? null : overviewResult?.openLast}</Descriptions.Item>
              <Descriptions.Item label="点击次数">{overviewResult?.clickUnique}</Descriptions.Item>
              <Descriptions.Item label="点击人数">{overviewResult?.clickTotal}</Descriptions.Item>
              <Descriptions.Item label="首次点击时间">{overviewResult?.clickFirst==='0000-00-00 00:00:00' ? null : overviewResult?.clickFirst}</Descriptions.Item>
              <Descriptions.Item label="最后点击时间">{overviewResult?.clickLast==='0000-00-00 00:00:00' ? null : overviewResult?.clickLast}</Descriptions.Item>
            </Descriptions>
            {/* <Table dataSource={toJS(overviewDetailResult)} pagination={false} rowKey="id" rowClassName={this.getRowClassName}>
              <Table.Column title='邮箱' dataIndex="email" key="email" ellipsis={true} />
              <Table.Column width={150} title='打开总数' dataIndex="openTotal" key="openTotal" ellipsis={true} />
              <Table.Column width={150} title='点击总数' dataIndex="clickTotal" key="clickTotal" ellipsis={true} />
              <Table.Column width={200} title='打开时间' dataIndex="openFirst" key="openFirst" ellipsis={true} />
              <Table.Column title='IP/地址' dataIndex="groupName" key="groupName" ellipsis={true} render={(text, record) => (
              <>
                <span title={record?.ipFirst}>{record?.ipFirst}</span><br />
                <span title={record?.addrFirst}>{record?.addrFirst}</span>
              </>
            )}/>
              <Table.Column title='浏览器/系统' dataIndex="browser" key="browser" ellipsis={true} render={(text, record) => (
              <>
                <span title={record?.browser}>{record?.browser}</span><br />
                <span title={record?.os}>{record?.os}</span>
              </>
            )}/>
            </Table> */}
          </Spin>
        </Modal>
      </>
    )
  }
}

export default withTranslation()(FormModal)
